import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { ShopMember, ShopStaff, StaffAssignableRole } from "@/api";
import { Badge } from "@osmix/ui/badge";
import { Button } from "@osmix/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@osmix/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const STAFF_ROLES: StaffAssignableRole[] = ["shop-manager", "shop-product-manager", "shop-order-manager", "shop-support"];
export function StaffPanel(t0) {
  const $ = _c(24);
  const {
    staff,
    loading: t1,
    editable: t2,
    onRoleChange,
    onRemove
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const editable = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  let t3;
  if ($[0] !== staff?.members) {
    t3 = staff?.members ?? [];
    $[0] = staff?.members;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const members = t3;
  let t4;
  if ($[2] !== staff?.invites) {
    t4 = staff?.invites ?? [];
    $[2] = staff?.invites;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const invites = t4;
  let t5;
  if ($[4] !== t) {
    t5 = t("staff.title");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <CardHeader><CardTitle>{t5}</CardTitle></CardHeader>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== editable || $[9] !== loading || $[10] !== members || $[11] !== onRemove || $[12] !== onRoleChange || $[13] !== t) {
    t7 = loading ? <p className="text-sm text-muted-foreground">{t("staff.loading")}</p> : members.length === 0 ? <p className="text-sm text-muted-foreground">{t("staff.empty")}</p> : <Table><TableHeader><TableRow><TableHead>{t("staff.member")}</TableHead><TableHead>{t("staff.role")}</TableHead><TableHead>{t("staff.status")}</TableHead>{editable && <TableHead className="text-right">{t("staff.actions")}</TableHead>}</TableRow></TableHeader><TableBody>{members.map(member => <TableRow key={member.id}><TableCell><div className="font-medium"><Link to={`/users/${member.userId}`} className="hover:underline">{member.name}</Link></div><div className="text-xs text-muted-foreground">{member.email}</div></TableCell><TableCell>{editable && member.role !== "shop-owner" ? <select className="h-9 rounded-md border bg-transparent px-3 text-sm" value={member.role} onChange={event => onRoleChange?.(member.id, event.target.value as StaffAssignableRole)}>{STAFF_ROLES.map(role => <option key={role} value={role}>{t(`roles.${role}`)}</option>)}</select> : <span>{t(`roles.${member.role}`)}</span>}</TableCell><TableCell><Badge variant={member.status === "active" ? "secondary" : "outline"}>{t(`staff.statuses.${member.status}`)}</Badge></TableCell>{editable && <TableCell className="text-right"><Button variant="outline" size="sm" disabled={member.role === "shop-owner"} onClick={() => onRemove?.(member.id)}>{t("staff.remove")}</Button></TableCell>}</TableRow>)}</TableBody></Table>;
    $[8] = editable;
    $[9] = loading;
    $[10] = members;
    $[11] = onRemove;
    $[12] = onRoleChange;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== invites || $[16] !== t) {
    t8 = invites.length > 0 && <div className="space-y-2"><h3 className="text-sm font-medium">{t("staff.pendingInvites")}</h3><div className="space-y-1 text-sm text-muted-foreground">{invites.map(invite => <div key={invite.id}>{invite.email} · {t(`roles.${invite.role}`)}</div>)}</div></div>;
    $[15] = invites;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <CardContent className="space-y-4">{t7}{t8}</CardContent>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t9) {
    t10 = <Card>{t6}{t9}</Card>;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
export const staffFromMemberships = (members: ShopMember[]): ShopStaff => ({
  members,
  invites: []
});